module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__scotiabank_White.4931ddc2.svg";